import React from "react";
import About from "../Components/About";
import ContactUs from "../Components/ContactUs";
import Github from "../Components/Github";
import Home from "../Components/home";
import Projects from "../Components/Projects";
import Skills from "../Components/Skills";
import Navbar from "../Components/Navbar";

const Homepage = () => {
  return (
    <>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Github />
      <ContactUs />
    </>
  );
};

export default Homepage;
